import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  activeVetListsContent: {
    textDecoration: "underline",
    cursor: "pointer",
    width: 30,
    height: 28,
    minWidth: 30,
    padding: 0,
    borderRadius: "50%",
    "&:hover": {
      textDecoration: "underline",
      cursor: "pointer"
    }
  }
});
